import { useRef, useEffect } from 'react';
import './PuppeteerLivePreviewer.css';

const PuppeteerLivePreviewer = ({ html, loading, theme }) => {
  const isDark = theme === 'dark';
  const iframeRef = useRef(null);

  // Auto-resize iframe to match its content height
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !html) return;

    const resizeIframe = () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (doc?.body) {
          iframe.style.height = doc.body.scrollHeight + 'px';
        }
      } catch {}
    };

    iframe.addEventListener('load', resizeIframe);
    return () => iframe.removeEventListener('load', resizeIframe);
  }, [html]);

  return (
    <div className={`plp-container ${isDark ? 'plp-dark' : ''}`}>
      <div className="plp-label">
        Live Preview
        {loading && <span className="plp-loading">Updating...</span>}
      </div>
      <div className="plp-frame">
        {html ? (
          <iframe
            ref={iframeRef}
            srcDoc={html}
            title="Resume Live Preview"
            className="plp-iframe"
            sandbox="allow-same-origin"
          />
        ) : (
          <div className="plp-empty">
            <div className="plp-empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            </div>
            <p>Start filling the form to see your live resume preview</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PuppeteerLivePreviewer;
